import React from "react";
import {Switch, Redirect, Route} from "react-router-dom";
import {
    Wallet,
    Profile,
    Claims,
    Favorites,
    NotFound,
    NextTravel,
    Notifications,
} from "../pages";
import {PrivateRoute} from "./private";
import {MENU} from "../utils/constants";
import {useKeycloak} from "@react-keycloak/web/lib/useKeycloak";
import StudentYoungProfileConfirmForm from "../pages/StudentYoungProfileConfirmForm";

export const Routes = () => {
    const {keycloak} = useKeycloak();

    return (
        <Switch>
            <Redirect exact from="/" to={MENU.WALLET.URL}/>
            <PrivateRoute
                path={MENU.WALLET.URL}
                component={Wallet}
                isAuthenticated={keycloak?.authenticated}
            />
            <PrivateRoute
                path={MENU.PROFILE.URL}
                component={Profile}
                isAuthenticated={keycloak?.authenticated}
            />
            <PrivateRoute
                path={MENU.FAVORITES.URL}
                component={Favorites}
                isAuthenticated={keycloak?.authenticated}
            />
            <PrivateRoute
                path={MENU.NEXT_TRAVEL.URL}
                component={NextTravel}
                isAuthenticated={keycloak?.authenticated}
            />
            {/*   <PrivateRoute
        path={MENU.MOUTEBE.URL}
        component={MouTeBe}
        isAuthenticated={keycloak?.authenticated}
      /> */}
            <PrivateRoute
                path={MENU.CLAIMS.URL}
                component={Claims}
                isAuthenticated={keycloak?.authenticated}
            />
            <PrivateRoute
                path={MENU.NOTIFICATIONS.URL}
                component={Notifications}
                isAuthenticated={keycloak?.authenticated}
            />
            <PrivateRoute
                path={MENU.STUDENT_YOUNG_PROFILE_CONFIRM_FORM.URL}
                component={StudentYoungProfileConfirmForm}
                isAuthenticated={keycloak?.authenticated}
            />
            <Route component={NotFound}/>
        </Switch>
    );
};